import {
    ApartmentBuildingModel,
    AreaProjectModel,
    ConstructionNumberModel,
    DistrictModel,
    ProjectPhaseModel,
    PropertyTypeModel,
} from '../generated';

const composeIncludeString = (
    keys: (
        | keyof ConstructionNumberModel
        | keyof PropertyTypeModel
        | keyof ApartmentBuildingModel
        | keyof ProjectPhaseModel
        | keyof DistrictModel
        | keyof AreaProjectModel
    )[],
) => {
    return keys.join(',');
};

export { composeIncludeString };
